import './payment.scss';
import '../product-details.scss';

export default class PaymentCtrl {

    // @ngInject
    constructor(signupDataStore, stripeConfig, stripeCheckout, responseHandler, countryData, OrderResource, usaStates, userGroup) {

        this.defaultMetadata = {
            is_company: false,
            company_name: undefined,
            vat_number: undefined
        };

        this.signupDataStore = signupDataStore;
        this.responseHandler = responseHandler;
        this.stripeConfig = stripeConfig;
        this.stripeCheckout = stripeCheckout;
        this.OrderResource = OrderResource;
        this.userGroup = userGroup;


        // Create order, as a result we get the
        // invoice id
        this.createOrder();

        responseHandler(countryData.query().$promise, 'fetching countries')
            .then((countries) => this.countries = countries);

        responseHandler(usaStates.query().$promise, 'fetching usa states')
            .then((data) => this.usaStates = data);

        this.data = {
            number: undefined,
            exp_month: undefined,
            exp_year: undefined,
            cvc: undefined,
            address_country: this.userGroup.country,
            metadata: angular.copy(this.defaultMetadata),
            address_zip: undefined,
            address_line1: undefined,
            address_city: undefined,
            address_state: undefined
        };
    }

    createOrder() {
        let checkout = this.OrderResource.checkout({
            product_id: this.signupDataStore.upgrade.plan.id
        });
        this.responseHandler(checkout.$promise, 'creating an order')
            .then((order) => this.setCheckoutDetails(order));
    }

    setCheckoutDetails(order) {
        this.signupDataStore.invoice = order.invoice;
        this.stripeConfig.key = order.stripe_public_key;
        this.order = order.pricing_details;
        this.cur = order.pricing_details.currency + '\u2008'; // &puncsp;

    }

    submit() {
        if (!this.data.metadata.is_company) {
            this.data.metadata = angular.copy(this.defaultMetadata);
        }

        this.stripeCheckout.runRemoteCheck().then((stripeData) => {
            this.signupDataStore.stripe = stripeData;
            this.signupDataStore.payment = this.data;
            this.next();
        });
    }

    next() {
        this.signupDataStore.upgrade.stage = 'review';
    }
}



// WEBPACK FOOTER //
// ./payments/payment/payment-ctrl.js